let apiUrl = "REACT_APP_ELMARK_API_URL";

export const config = apiUrl;
